module.exports = global["Modernizr"] = require("-!/usr/src/app/node_modules/modernizr-loader/index.js!/usr/src/app/node_modules/json-loader/index.js!./modernizrrc.json");


//////////////////
// WEBPACK FOOTER
// ../config/modernizrrc.json-exposed
// module id = 462
// module chunks = 1